<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <div v-if="$route.meta.historyback" class="p-grid p-ai-center p-pt-1 vertical-container">
          <div class="p-col-fixed" style="width:55px;">
              <a @click="$functions.historyBack()" style="cursor: pointer">
                <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
              </a>
          </div>
          <div class="p-col">
              <h3>{{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}} - {{$t('haccp.title')}}</h3>
          </div>
      </div>
      <h2 v-else><a href="#/haccp">{{$t('haccp.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}}</h2>

        <div class="irinox-form haccp" >

          <div class="search-bar" style="float: right">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('haccp.search')" :aria-label="$t('haccp.search')"/>
            <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <Dropdown id="period" v-model="periodSelected" :options="periods" optionLabel="name" optionValue="code"
                :placeholder="$t('haccp.period')" />
            </div>
          </div>

           <DataTable :value="reports" stripedRows 
            v-model:filters="filters" responsiveLayout="stack" 
            breakpoint="960px" >
            <template #empty>
                {{$t('haccp.report_empty_list')}}
            </template>
            <template #loading>
                {{$t('haccp.report_loading_list')}}
            </template>

            <Column field="timsetamp" :header="$t('haccp.col_date_time')" >
              <template #body="slotProps">
                <div :class="[{'date-error':!slotProps.data.processed}]">
                  {{ $d( $functions.utcDate(slotProps.data.timestamp,msConverter) , is24hour ? 'long' : 'long12' ) }}
                </div>
              </template>
            </Column>

            <Column field="cycleName" :header="$t('haccp.col_cycle')" >
              <template #body="slotProps">
                <div>
                  {{slotProps.data.cycleName ?? '-'}} 
                </div>
              </template>
            </Column>

            <!-- <Column v-if="(appliance.type=='ABBATTITORE' && appliance.gamma=='MF Next') || appliance.type=='CONSERVATORE'" field="energy" :header="$t('haccp.col_energy')" >
              <template #body="slotProps">
                <div>
                  {{slotProps.data.energy ? $n(slotProps.data.energy)+' kWh' : ''}}
                </div>
              </template>
            </Column> -->

            <Column field="reportId" :header="$t('haccp.col_report')" >
              <template #body="slotProps">
                <div v-if="slotProps.data.reportId != null" class="p-d-flex p-ai-center">
                  <img v-if="!$functions.isDemoMode(email)" class="download-button" src="assets/irinox/icons/download.svg" @click="downloadDialog($event, slotProps.data.reportId, slotProps.data.timestamp)" :alt="$t('common.download')"/>
                  <i v-if="role!='USER' && !role.includes('SERVICE') && !slotProps.data.processed" class="pi pi-exclamation-triangle p-ml-2" style="color: orange; font-size: 1.3rem;" v-tooltip.left="slotProps.data.parsingError ?? 'ERROR'"></i>
                </div>
              </template>
            </Column>

          </DataTable>

          <OverlayPanel ref="op" class="download-op" style="width: 200px">
            <div @click="download($event, 'csv')">{{$t('haccp.download_csv')}}</div>
            <div @click="download($event, 'pdf')">{{$t('haccp.download_pdf')}}</div>
          </OverlayPanel>

        </div>
		</div>
	</div>

  <!--                    -->
  <!-- ERRORS AND SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('haccp.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('haccp.error_dialog')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('haccp.download_report_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import EventHubListenerService from '../../service/EventHubListenerService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import {FilterMatchMode} from 'primevue/api';
import { mapGetters } from 'vuex';

export default {
    components: {
      IrinoxDialogDark
    },
    data() {
        return {
          msConverter: 1000, //Set it to 1000 if API response is in seconds or to 1 if milliseconds 
          serialNumber: this.$route.params.serialNumber,
          reports: [],
          periods: [{
            code: 7,
            name: this.$t('haccp.period_last_w')
          },{
            code: 30,
            name: this.$t('haccp.period_last_1m')
          },{
            code: 60,
            name: this.$t('haccp.period_last_2m')
          },{
            code: 90,
            name: this.$t('haccp.period_last_3m')
          }],
          periodSelected: 90,
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
          },
          dialog: {
            error: false,
            blockingError: false,
            success: false
          },
          currentReport: {
            reportId: null,
            timestamp: null
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          is24hour: 'userdata/is24hour',
          role: 'userdata/role',
          email: 'userdata/email',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
    },
    watch: {
      periodSelected: 'reloadReports'
    },
    created() {
      this.eventHubListenerService = new EventHubListenerService();
    },
    mounted() {
      this.reloadReports();
    },
    methods: {
      reloadReports() {
        let days = this.periodSelected ? this.periodSelected : 90;
        let startTimestamp = parseInt(new Date().getTime()/this.msConverter-((60*60*24)*days));
        this.eventHubListenerService.getHaccpReports(this.personaltoken, this.serialNumber, startTimestamp)
          .then((data) => {
            if(data.code=="200") {
              this.reports = data.body;
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      },
      downloadDialog(event, reportId, timestamp) {
        this.currentReport.reportId = reportId;
        this.currentReport.timestamp = timestamp;
        this.$refs.op.toggle(event);
      },
      download(event, type) {
        this.$refs.op.toggle(event);
        let httpType = "application/pdf";
        if(type == 'csv') {
          httpType = "application/vnd.ms-excel";
        }
        this.eventHubListenerService.downloadHaccpReport(this.personaltoken, this.currentReport.reportId, type)
          .then((res) => {
            let contentType = res.headers["content-type"];
            if(contentType !== 'application/json') {
              let filename = "haccp_"+this.serialNumber+"_"+this.currentReport.timestamp+"."+type;
              let contentDisposition = res.headers["content-disposition"];
              if(contentDisposition) {
                filename = contentDisposition.replace(/.*filename="(.*)".*/g,"$1");
              }
              this.dialog.success = true;
              let blob=new Blob([res.data], {type: httpType});
              let link=document.createElement('a');
              link.href=window.URL.createObjectURL(blob);
              link.download=filename;
              link.click();
            } else {
              this.dialog.error = true;
              console.error("EXCEPTION "+JSON.stringify(res));
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      }
    }
}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

.irinox-form .search-bar input {
  width: 100px;
}

.download-button {
  cursor: pointer;
}

</style>